import { ToastTypes } from '@/types';
import { createSlice } from '@reduxjs/toolkit';

interface SystemState {
  toastMessage: string;
  toastType: ToastTypes;
  toastTitle: string;
  isToastVisible: boolean;
  isAgentModalOpen: boolean;
}

const initialState: SystemState = {
  toastMessage: 'init',
  toastType: 'info', 
  toastTitle: '',
  isToastVisible: false,
  isAgentModalOpen: false,
};

const systemSlice = createSlice({
  name: 'system', 
  initialState,
  reducers: {
    setToast: (state, action) => {
      state.toastMessage = action.payload.toastMessage;
      state.toastType = action.payload.toastType;
      state.toastTitle = action.payload.toastTitle;
      state.isToastVisible = true;
    },
    setIsAgentModalOpen: (state, action) => {
      state.isAgentModalOpen = action.payload;
    },
    hideToast: (state) => {
      state.isToastVisible = false;
    }
  },
});

export const { setToast, hideToast, setIsAgentModalOpen } = systemSlice.actions;
export default systemSlice.reducer;
